import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { SkipToContent } from '@/components/SkipToContent';
import { CommandPalette } from '@/components/CommandPalette';
import { CommandPaletteContext } from '@/hooks/useCommandPalette';
import { useAnalytics } from '@/hooks/useAnalytics';
import { AuthProvider } from '@/hooks/useAuth';

export default function RootLayout() {
  const [open, setOpen] = useState(false);
  useAnalytics();

  return (
    <AuthProvider>
      <CommandPaletteContext.Provider value={{ open, setOpen }}>
        <ScrollToTop />
        <SkipToContent />
        <Header />
        <main id="main" className="min-h-[calc(100vh-12rem)]">
          <Outlet />
        </main>
        <Footer />
        <CommandPalette />
      </CommandPaletteContext.Provider>
    </AuthProvider>
  );
}
